/* @flow */

export default {
  manualAction: {
    display: 'flex',
    justifyContent: 'center',
  },
};
